const PROBE_TIMEOUT_MS = 6000;
let probeSequence = 0;

// 加载本站已有的小图标，跨域不依赖 CORS；只有图片加载成功才记录耗时。
// 这是浏览器资源加载时间（含连接、传输和解码），不是带宽或 AI 推理速度。
export const measureRouteSpeed = (origin, signal) => new Promise(resolve => {
  if (signal.aborted) {
    resolve({ status: 'cancelled' });
    return;
  }

  const probe = new Image();
  const url = new URL('/favicon.ico', origin);
  url.searchParams.set('_route_probe', `${Date.now()}-${++probeSequence}`);
  const startedAt = performance.now();
  let settled = false;
  let timer;

  const finish = result => {
    if (settled) return;
    settled = true;
    window.clearTimeout(timer);
    probe.onload = null;
    probe.onerror = null;
    signal.removeEventListener('abort', onAbort);
    probe.removeAttribute('src');
    resolve(result);
  };
  const onAbort = () => finish({ status: 'cancelled' });
  probe.referrerPolicy = 'no-referrer';
  probe.onload = () => finish({ status: 'success', milliseconds: Math.max(1, Math.round(performance.now() - startedAt)) });
  probe.onerror = () => finish({ status: 'error' });
  signal.addEventListener('abort', onAbort, { once: true });
  timer = window.setTimeout(() => finish({ status: 'timeout' }), PROBE_TIMEOUT_MS);
  probe.src = url.toString();
});
